var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpotify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#50B95D"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#20A83E"
    },
    d: "M34.133,256c0-135.648,105.508-246.636,238.933-255.42C267.424,0.208,261.737,0,256,0 C114.615,0,0,114.615,0,256s114.615,256,256,256c5.737,0,11.424-0.208,17.067-0.58C139.642,502.636,34.133,391.648,34.133,256z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M358.23,335.212L358.23,335.212c-48.438-21.419-100.06-32.278-153.43-32.278 c-31.435,0-62.695,3.854-92.913,11.454c-11.408,2.869-18.355,14.485-15.485,25.893c2.869,11.406,14.483,18.353,25.893,15.485 c26.816-6.746,54.575-10.165,82.506-10.165c47.392,0,93.207,9.634,136.176,28.635c8.213,3.631,18.391,1.478,24.423-5.178 c5.613-6.194,6.945-15.57,3.569-23.173C366.867,341.153,362.961,337.303,358.23,335.212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M386.652,259.147c-57.538-24.737-118.722-37.28-181.852-37.28c-31.25,0-62.486,3.15-92.839,9.361 c-13.662,2.796-22.749,16.529-19.949,30.212c2.829,13.822,16.377,22.777,30.212,19.948c26.986-5.521,54.768-8.321,82.576-8.321 c56.134,0,110.515,11.142,161.63,33.118c9.554,4.107,21.119,1.799,28.405-5.61c7.328-7.452,9.173-19.09,4.917-28.574 C397.177,266.262,392.429,261.631,386.652,259.147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M444.853,196.524c-2.849-7.452-8.429-13.348-15.712-16.603 C358.38,148.3,282.901,132.267,204.8,132.267c-36.37,0-72.745,3.573-108.113,10.621c-11.318,2.255-20.645,11.296-23.27,22.532 c-2.902,12.42,2.736,25.532,13.526,32.211c6.365,3.94,14.074,5.305,21.417,3.838C139.894,195.186,172.341,192,204.8,192 c69.648,0,136.928,14.285,199.971,42.457c8.618,3.852,18.891,3.334,27.07-1.381c7.268-4.191,12.572-11.468,14.337-19.669 C447.383,207.802,446.899,201.874,444.853,196.524z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.f27b548c4a2b2c294942f5610c37b495.svg";
export { ForwardRef as ReactComponent };